import { __assign, __rest } from "tslib";
import { startCase } from 'lodash-es';
import React from 'react';
import { Box, Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsPanelProperty } from '@marvelapp/ui-internal';
import { NORMAL } from '../../constants/blendMode';
import Measurement from '../../containers/handoff/Measurement';
export default function PanelProperties(_a) {
    var _b = _a.blendMode, blendMode = _b === void 0 ? NORMAL : _b, _c = _a.blur, blur = _c === void 0 ? 0 : _c, layout = _a.layout, _d = _a.opacity, opacity = _d === void 0 ? 1 : _d, radius = _a.radius;
    return (React.createElement(SpecsPanel, { title: "Properties" },
        React.createElement(Flex, { flexWrap: "wrap", marginBottom: -3 },
            React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "Width" },
                    React.createElement(Measurement, { value: layout.width }))),
            React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "Height" },
                    React.createElement(Measurement, { value: layout.height }))),
            React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "X Pos" },
                    React.createElement(Measurement, { value: layout.x }))),
            React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "Y Pos" },
                    React.createElement(Measurement, { value: layout.y }))),
            opacity < 1 && (React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "Opacity" }, "".concat(Math.round(opacity * 100), "%")))),
            blur > 0 && (React.createElement(FlexItem, null,
                React.createElement(SpecsPanelProperty, { label: "Blur" },
                    React.createElement(Measurement, { value: blur })))),
            blendMode !== NORMAL && (React.createElement(FlexItem, { width: 1 / 2 },
                React.createElement(SpecsPanelProperty, { label: "Blending Mode" }, startCase(blendMode)))),
            radius && React.createElement(BorderRadius, { radii: radius }))));
}
function BorderRadius(_a) {
    var radii = _a.radii;
    if (allEqual(radii)) {
        var elementHasRadius = radii[0] !== 0;
        if (elementHasRadius) {
            return (React.createElement(FlexItem, { width: 1 / 2 },
                React.createElement(SpecsPanelProperty, { label: "Border Radius" },
                    React.createElement(Measurement, { value: radii[0] }))));
        }
        return null;
    }
    return (React.createElement(FlexItem, { width: 1 / 2 },
        React.createElement(SpecsPanelProperty, { label: "Border Radius" }, radii
            .map(function (radius, index) { return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Measurement, { key: index, value: radius })); })
            .reduce(function (prev, curr) { return [prev, ' ', curr]; }))));
}
function FlexItem(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ marginBottom: 20, width: 1 / 4 }, props), children));
}
function allEqual(array) {
    var first = array[0];
    return array.every(function (el) { return el === first; });
}
